export const GOOGLE_MAPS_REQUESTED_FIELDS: string[] = [
  'address_components',
  'place_id',
  'name',
  'formatted_address',
  'geometry.location',
];
